/**
 * Centralized menu option IDs used across the application
 */

// Tile dashboard menu options (when clicking on tiles)
export enum TileMenuOptionId {
  CONFIGURE = 'conf',
  HISTORY = 'hist',
  SCHEDULES = 'sch',
  CHAT = 'chat',
}

// Table kebab menu options (for hubs, tiles, basic entities)
export enum TableMenuOptionId {
  CONFIGURE = 'configure',
  DELETE = 'delete',
  CHAT = 'chat',
  BULK_SELECT = 'bulk',
  VIEW_DEVICES = 'devices',
}

// Device table menu options (extends table options with device-specific ones)
export enum DeviceMenuOptionId {
  CONFIGURE = 'configure',
  DELETE = 'delete',
  CHAT = 'chat',
  VIEW_TILES = 'tiles',
  DISCOVER_POINTS = 'discover',
  RESET_TIMEOUT = 'timeout',
  CONFIGURE_MODBUS_POINTS = 'modbus_conf',
}

// Alarm menu options
export enum AlarmMenuOptionId {
  VIEW_DETAILS = 'details',
  ACKNOWLEDGE = 'ack',
  CLEAR = 'clear',
}